export default {
  successChangeLanguage: 'Language has been successfully changed',
  successReleaseBaseTranslation: 'Base translation has been successfully released',
};
